import { portalApiClient } from '@/utilities/api'

export const getPatientPartnerIds = (orgId: string) =>
  portalApiClient.org_partners_v2_auth_organizations__org_id__clients_get({
    params: { org_id: orgId },
  })

export const getPartnerById = getPatientPartnerIds

const partnerService = {
  getPatientPartnerIds,
  getPartnerById,
}

export default partnerService
